import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { LogIn } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";

export default function AdminLogin() {
  const { user, login, loading } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  if (loading) return <div className="min-h-screen flex items-center justify-center text-[var(--slate)]">Yükleniyor…</div>;
  if (user) return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(email, password);
      toast.success("Hoş geldiniz");
      navigate("/admin");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Giriş başarısız");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--ivory)] px-6 relative overflow-hidden" data-testid="admin-login-page">
      <div className="pointer-events-none absolute -top-32 -right-32 w-[500px] h-[500px] border border-[var(--gold)]/15 rounded-full" />
      <div className="pointer-events-none absolute -bottom-32 -left-32 w-[500px] h-[500px] border border-[var(--gold)]/15 rounded-full" />

      <form onSubmit={onSubmit} className="relative w-full max-w-md bg-[var(--cream)] border border-[var(--gold)]/30 p-10 lg:p-12">
        <span className="absolute top-3 right-3 w-8 h-8 border-t border-r border-[var(--gold)]" />
        <span className="absolute bottom-3 left-3 w-8 h-8 border-b border-l border-[var(--gold)]" />

        <div className="flex justify-center mb-8">
          <Logo variant="light" size="lg" />
        </div>
        <h1 className="font-serif-luxe text-3xl text-center text-[var(--navy)]">Yönetim Paneli</h1>
        <div className="gold-divider w-20 mx-auto my-4" />
        <p className="text-center text-sm text-[var(--slate)] font-light mb-8">Devam etmek için giriş yapın</p>

        <label className="block text-xs tracking-[0.18em] uppercase text-[var(--navy)] mb-2">E-posta</label>
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          data-testid="login-email"
          className="w-full bg-transparent border-b border-[var(--navy)]/30 focus:border-[var(--gold)] outline-none py-2 mb-6 font-light"
          placeholder="admin@ozkayalar.com"
        />

        <label className="block text-xs tracking-[0.18em] uppercase text-[var(--navy)] mb-2">Parola</label>
        <input
          type="password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          data-testid="login-password"
          className="w-full bg-transparent border-b border-[var(--navy)]/30 focus:border-[var(--gold)] outline-none py-2 mb-10 font-light"
          placeholder="••••••••"
        />

        <button type="submit" disabled={submitting} className="btn-primary w-full justify-center" data-testid="login-submit">
          <LogIn size={16} /> {submitting ? "Giriş yapılıyor…" : "Giriş Yap"}
        </button>
      </form>
    </div>
  );
}
